'use client';

import { cn } from '@module/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';
import { TagContext } from './context/useTagContext';
import { tagCva } from './styles';
import type { TagSize, TagTone, TagVariant } from './types';

export type TagRootProps = React.HTMLAttributes<HTMLSpanElement> & {
  asChild?: boolean;
  variant?: TagVariant; // 'soft' | 'solid'
  tone?: TagTone; // 'mint' | 'red' | 'yellow' | 'blue' | 'gray' | 'green' | 'purple' | 'black' | 'emphasis' | 'lightGray'
  size?: TagSize; // 'small' | 'medium' | 'large'
  disabled?: boolean;
};

export const TagRoot = React.forwardRef<HTMLSpanElement, TagRootProps>(
  ({ asChild, className, variant = 'soft', tone = 'gray', size = 'small', disabled, children, ...rest }, ref) => {
    const Comp = asChild ? Slot : 'span';

    return (
      <TagContext.Provider value={{ size, tone, variant, disabled }}>
        <Comp
          ref={ref as any}
          role='status'
          aria-disabled={disabled || undefined}
          className={cn(tagCva({ variant, tone, size, disabled: !!disabled }), 'rounded-full', className)}
          {...rest}
        >
          {children}
        </Comp>
      </TagContext.Provider>
    );
  },
);
TagRoot.displayName = 'TagRoot';
